import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/pages/TermsOfServicePage.css';

const TermsOfServicePage = () => {
  return (
    <div className="policy-page-container">
      <div className="return-link-container return-link-top">
        <Link to="/" className="return-link">← Return to The Icing Calculator</Link>
      </div>
      <h1>Terms of Service for The Icing Calculator</h1>
      <p>Last updated: {new Date().toLocaleDateString()}</p>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing and using The Icing Calculator (the "Service"), you accept and agree to be bound by the terms and provision of this agreement. 
          In addition, when using these particular services, you shall be subject to any posted guidelines or rules applicable to such services. 
          Any participation in this service will constitute acceptance of this agreement.
        </p>
      </section>

      <section>
        <h2>2. Description of Service</h2>
        <p>
          Our Service provides tools and calculations for cookie decorating. The Basic Calculator is available for all users. 
          The Pro Calculator offers advanced features and requires user registration.
        </p>
      </section>

      <section>
        <h2>3. User Conduct</h2>
        <p>
          You agree to use the Service only for lawful purposes. You are responsible for all of your activity in connection with the Service. 
          You shall not (and shall not permit any third party to) either (a) take any action or (b) upload, download, post, submit or otherwise distribute or facilitate distribution of any content on or through the Service that:
        </p>
        <ul>
          <li>infringes any patent, trademark, trade secret, copyright, right of publicity or other right of any other person or entity;</li>
          <li>is unlawful, threatening, abusive, harassing, defamatory, libelous, deceptive, fraudulent, invasive of another's privacy, tortious, obscene, offensive, or profane;</li>
          <li>constitutes unauthorized or unsolicited advertising, junk or bulk e-mail ("spamming");</li>
          <li>involves commercial activities and/or sales without our prior written consent such as contests, sweepstakes, barter, advertising, or pyramid schemes;</li>
          <li>impersonates any person or entity, including any of our employees or representatives.</li>
        </ul>
      </section>
      
      <section>
        <h2>4. User Accounts</h2>
        <p>
          To access certain features of the Service (e.g., Pro Calculator), you may be required to create an account. 
          You are responsible for maintaining the confidentiality of your account password and for all activities that occur under your account. 
          You agree to notify us immediately of any unauthorized use of your account.
        </p>
      </section>

      <section>
        <h2>5. Intellectual Property</h2>
        <p>
          The Service and its original content, features, and functionality are and will remain the exclusive property of The Icing Calculator and its licensors. 
          The Service is protected by copyright, trademark, and other laws of both the United States and foreign countries. 
          Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of The Icing Calculator.
        </p>
      </section>

      <section>
        <h2>6. Disclaimer of Warranties and Limitation of Liability</h2>
        <p>
          The information, tools, and calculations provided on this Service are for informational and planning purposes only. 
          While we strive to provide accurate and up-to-date information, the Service is provided "AS IS" and "AS AVAILABLE" without any warranties of any kind, express or implied, including but not limited to, implied warranties of merchantability, fitness for a particular purpose, or non-infringement.
        </p>
        <p>
          The Icing Calculator does not warrant that a) the Service will function uninterrupted, secure or available at any particular time or location; b) any errors or defects will be corrected; c) the Service is free of viruses or other harmful components; or d) the results of using the Service will meet your requirements or expectations.
        </p>
        <p>
          Your use of the Service is solely at your own discretion and understanding of its capabilities and limitations. 
          In no event shall The Icing Calculator, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service; (ii) any conduct or content of any third party on the Service; (iii) any content obtained from the Service; and (iv) unauthorized access, use or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence) or any other legal theory, whether or not we have been informed of the possibility of such damage, and even if a remedy set forth herein is found to have failed of its essential purpose.
        </p>
      </section>

      <section>
        <h2>7. Governing Law</h2>
        <p>
          These Terms shall be governed and construed in accordance with the laws of [Your State/Country, e.g., California, United States], without regard to its conflict of law provisions.
        </p>
      </section>

      <section>
        <h2>8. Changes to Terms</h2>
        <p>
          We reserve the right, at our sole discretion, to modify or replace these Terms at any time. 
          If a revision is material we will try to provide at least 30 days' notice prior to any new terms taking effect. 
          What constitutes a material change will be determined at our sole discretion.
        </p>
      </section>

      <section>
        <h2>9. Contact Us</h2>
        <p>
          If you have any questions about these Terms, please contact us at:
          <br />
          Email: <a href="mailto:support@theicingcalculator.com">support@theicingcalculator.com</a>
        </p>
      </section>
      <div className="return-link-container return-link-bottom">
        <Link to="/" className="return-link">← Return to The Icing Calculator</Link>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
